import { useNavigate } from "react-router-dom";
import { Button } from "../../../../core/components/atoms/Button";
import { useFilterConfigStore } from "../../stores/filterConfig";

interface IContentButtonGroup {
  type: string;
  contentUrl: string;
}

const ContentButtonGroup: React.FC<IContentButtonGroup> = ({ type, contentUrl }) => {
  const navigate = useNavigate();
  const { resetOnChange } = useFilterConfigStore();

  return (
    <div className='flex w-full flex-row gap-xl overflow-auto'>
      <Button
        onClick={() => {
          resetOnChange();
          navigate(contentUrl+"/tipo/videoaula")
        }}
        variant={type === 'videoaula' ? 'contained' : 'outlined'}
        className='rounded-pill border-color-brand-primary'
      >
        Videoaulas
      </Button>
      <Button
        onClick={() => {
          resetOnChange();
          navigate(contentUrl+"/tipo/exercicio")
        }}
        variant={type === 'exercicio' ? 'contained' : 'outlined'}
        className='rounded-pill border-color-brand-primary'
      >
        Exercícios
      </Button>
      <Button
        onClick={() => {
          resetOnChange();
          navigate(contentUrl+"/tipo/materiais")
        }}
        variant={type === 'materiais' ? 'contained' : 'outlined'}
        className='rounded-pill border-color-brand-primary'
      >
        Materiais
      </Button>
    </div>
  )
}

export default ContentButtonGroup;